<template>
  <div class="news-list">
    <BasePage mode="list">
      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="listData"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="Plate"
            label="轮播模块"
            :show-overflow-tooltip="true"
          ></el-table-column>

          <el-table-column label="操作" width="80" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </BasePage>
    <ModuleEdit
      v-if="formVisible"
      :dataForm="formData"
      :formTitle="formTitle"
      @formCallBack="formCallBack"
    ></ModuleEdit>
    <edit-form v-if="visible" :dataForm="formData" formTitle="浮窗管理" @onOk="onOk()" />
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import ModuleEdit from "@/modules/zjrc/pages/basics/slideshow/edit";
import EditForm from "./editForm.vue";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "list",
  data() {
    return {
      isloading: false, //加载控制
      listData: [], //表格数据
      headerRow: "header-row",
      formVisible: false, //弹窗控制
      formTitle: "", //弹窗标题
      formData: {}, //弹窗数据
      visible: false,
    };
  },
  methods: {
    onOk(){
      const vm = this
      vm.visible = false
      vm.loadData()
    },
    //初始化数据
    loadData(TypeId) {
      this.isloading = true;
      this.formData = {
        TypeId: TypeId || "",
      };
      api.QuerySlideShow().then((rep) => {
        if (rep.data.Code === 0) {
          this.total = rep.data.Data.total;
          this.listData = rep.data.Data.rows;
        }
        this.isloading = false;
      });
    },
    //编辑
    innerEdit(rowData) {
      this.formData = Object.assign({}, rowData);
      if (rowData.Location === "FloatWindow") {
        this.visible = true;
      } else {
        this.formTitle = "修改轮播图";
        this.formVisible = true;
      }
    },
    //回调
    formCallBack(data) {
      this.formVisible = false;
      if (data != null) {
        this.loadData();
      }
    },
    //表格高度控制
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 213;
      }
      return tableMaxHeight;
    },
  },
  components: {
    BasePage,
    ModuleEdit,
    EditForm,
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"]),
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped></style>
